import gql from 'graphql-tag';

export default gql`
  mutation AdminSignup(
    $email: String!
    $password: String!
    $companyName: String!
    $userRole: String!
  ) {
    signupUser(
      email: $email
      password: $password
      companyName: $companyName
      userRole: $userRole
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/Signup.ts